const norm = (s) => (s || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[^a-z0-9]+/g, " ").trim();

export const distanceKm = (a, b) => {
  const rad = (d) => (d * Math.PI) / 180;
  const dLat = rad(b.lat - a.lat);
  const dLng = rad(b.lng - a.lng);
  const h = Math.sin(dLat / 2) ** 2 + Math.cos(rad(a.lat)) * Math.cos(rad(b.lat)) * Math.sin(dLng / 2) ** 2;
  return 12742 * Math.asin(Math.sqrt(h));
};

const hasCoords = (p) => typeof p?.lat === "number" && typeof p?.lng === "number";

// A concert belongs to a place when its venue carries the place's name, or when both points are within ~150 m.
export const eventsAtPlace = (place, events) => {
  const name = norm(place.name);
  return events.filter((e) => {
    const venue = norm(e.venue);
    if (venue && name && (venue.includes(name) || name.includes(venue))) return true;
    return hasCoords(place) && hasCoords(e) && distanceKm(place, e) < 0.15;
  });
};

export const formatKm = (km) => (km < 1 ? `${Math.round(km * 1000)} m` : `${km < 10 ? km.toFixed(1).replace(".", ",") : Math.round(km)} km`);
